import { render, staticRenderFns } from "./BLayoutList.vue?vue&type=template&id=7413d563&"
import script from "./BLayoutList.vue?vue&type=script&lang=js&"
export * from "./BLayoutList.vue?vue&type=script&lang=js&"
import style0 from "./BLayoutList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VLayout } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VLayout,VSkeletonLoader,VSpacer})
